import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";
import Card from "../../productsList/Card";

const BuyPageResponsive = () => {
    const products = [{
        "name":"کاور محافظ ژله‌ای مدل TPU ",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "2,370,000 ",
        "type_card": "blue",
        "id": 1_1100,
    },{
        "name":"محافظ صفحه شیشه‌ای  ",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "2,370,000 ",
        "type_card": "blue",
        "id": 1_1105,
    },
        ,{
            "name":"محافظ صفحه شیشه‌ای  ",
            "img": "./assets/sample-image/1420-w320h320.png",
            "price": "2,370,000 ",
            "type_card": "blue",
            "id": 1_14405,
        },
        ,{
            "name":"محافظ صفحه شیشه‌ای  ",
            "img": "./assets/sample-image/1420-w320h320.png",
            "price": "2,370,000 ",
            "type_card": "blue",
            "id": 1_185,
        },
    ];
    return (
        <div className="buy-page-responsive-wrapper d-block d-lg-none">
            <div className="selection-color-responsive">
                <div className="selection-header d-flex" id="back-color-selection-responsive">
                    <IconName name="arrow_back" className="icon"/>
                    <h2 className="title">Xiaomi Redmi Note 9 Pro Global this text for test bug in top header title </h2>
                </div>
                <div className="selection-content xpx-4 xpt-10 xpb-8">
                    <div className="title-selection xmb-4"><span className="title">رنگ مورد نظر؟</span></div>
                    <div className="list-selection">
                        <ul className="list-unstyled">
                            <li className="d-flex justify-content-between align-items-center active selection-color">
                                <div className="selection-name"><span
                                    className="black color-box"></span>مشکی
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-color">
                                <div className="selection-name"><span
                                    className="white color-box"></span>سفید
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-color">
                                <div className="selection-name"><span
                                    className="green color-box"></span>فیروزه ای
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-color">
                                <div className="selection-name"><span className="blue color-box"></span>آبی
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-color">
                                <div className="selection-name"><span className="red color-box"></span>قرمز
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="buy-step-fixed-responsive position-fixed">
                    <div className=" d-flex justify-content-between align-items-center">
                        <div className="price">
                            <IconName name="cart" className="icon"/>
                            <span className="persian-number">۵،۴۸۹،۰۰۰ ت</span>
                        </div>
                        <div className="progress-buy">
                            <span className="item active"></span>
                            <span className="item"></span>
                            <span className="item"></span>
                            <span className="item"></span>
                        </div>
                        <div className="button-next">
                            <div className="next-page-buy" id="next-page-color-selection">
                                <span className="text">بعدی</span>
                                <IconName name="chevron_left" className="icon"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ram-selection-responsive">
                <div className="selection-header d-flex" id="back-ram-selection-responsive">
                    <IconName name="arrow_back" className="icon"/>
                    <h2 className="title">Xiaomi Redmi Note 9 Pro Global Dual </h2>
                </div>
                <div className="selection-content xpx-4 xpt-10 xpb-8">
                    <div className="title-selection xmb-4"><span className="title">مقدار حافظه‌ی داخلی؟</span></div>
                    <div className="list-selection">
                        <ul className="list-unstyled persian-number">
                            <li className="d-flex justify-content-between align-items-center active selection-ram">
                                <div className="selection-name">64 گیگ
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-ram">
                                <div className="selection-name">۱۲۸ گیگ
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-ram">
                                <div className="selection-name">۲۵۶ گیگ
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-ram">
                                <div className="selection-name">۵۱۲ گیگ
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
                <div className="buy-step-fixed-responsive position-fixed">
                    <div className=" d-flex justify-content-between align-items-center">
                        <div className="price">
                            <IconName name="cart" className="icon"/>
                            <span className="persian-number">۵،۴۸۹،۰۰۰ ت</span>
                        </div>
                        <div className="progress-buy">
                            <span className="item active"></span>
                            <span className="item active"></span>
                            <span className="item"></span>
                            <span className="item"></span>
                        </div>
                        <div className="button-next" id="nex-page-ram-buy">
                            <div className="next-page-buy">
                                <span className="text">بعدی</span>
                                <IconName name="chevron_left" className="icon"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="warranty-selection-responsive">
                <div className="selection-header d-flex" id="back-warranty-selection-responsive">
                    <IconName name="arrow_back" className="icon"/>
                    <h2 className="title">Xiaomi Redmi Note 9 Pro Global Dual </h2>
                </div>
                <div className="selection-content xpx-4 xpt-10 xpb-8">

                    <div className="title-selection"><span className="title">خدمات پس از فروش؟</span>
                        <p className="text-warranty xmt-2">گارانتی 7 روز بازگشت برای کالاهای بدون گارانتی
                            شرکتی بوده و خدمات کالاهای گارانتی دار، تماما به عهده شرکت گارانتی کننده می
                            باشد.</p>
                    </div>
                    <div className="list-selection">
                        <ul className="list-unstyled persian-color">
                            <li className="d-flex justify-content-between align-items-center active selection-warranty">
                                <div className="selection-name"><IconName name="verified_user"
                                                                          className="icon"/>گارانتی ۱۸
                                    ماهه‌ی سایمان
                                </div>
                                <div className="price"><span
                                    className="persian-number">5,489,000 ت</span>
                                </div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center selection-warranty">
                                <div className="selection-name"><IconName name="noshield"
                                                                          className="icon"/>گارانتی ۱۸
                                    ماهه‌ی سایمان
                                </div>
                                <div className="price"><span
                                    className="persian-number">۶،۸۳۹،۰۰۰ ت</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="buy-step-fixed-responsive position-fixed">
                    <div className=" d-flex justify-content-between align-items-center">
                        <div className="price">
                            <IconName name="cart" className="icon"/>
                            <span className="persian-number">۵،۴۸۹،۰۰۰ ت</span>
                        </div>
                        <div className="progress-buy">
                            <span className="item active"></span>
                            <span className="item active"></span>
                            <span className="item active"></span>
                            <span className="item"></span>
                        </div>
                        <div className="button-next" id="nex-page-warranty-buy">
                            <div className="next-page-buy">
                                <span className="text">بعدی</span>
                                <IconName name="chevron_left" className="icon"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="accessories-selection-responsive">
                <div className="selection-header d-flex" id="back-accessories-selection-responsive">
                    <IconName name="arrow_back" className="icon"/>
                    <h2 className="title">Xiaomi Redmi Note 9 Pro Global Dual </h2>
                </div>
                <div className="selection-content xpx-4 xpt-10 xpb-8">
                    <div className="title-selection xmb-4"><span className="title">انتخاب لوازم جانبی</span></div>
                    <div className="list-selection">
                        <div className="row">
                            {products && products.map((product) => (
                                <div className="col-6 col-md-4" key={product.id}>
                                    <div className="box-cards">
                                        <Card product={product}/>
                                        <div className="add-card">
                                            <IconName name="add" className="icon"/>
                                            <span className="text">افزودن به سبد خرید</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="buy-step-fixed-responsive position-fixed">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="price">
                            <IconName name="cart" className="icon"/>
                            <span className="persian-number">۵،۴۸۹،۰۰۰ ت</span>
                        </div>
                        <div className="progress-buy">
                            <span className="item active"></span>
                            <span className="item active"></span>
                            <span className="item active"></span>
                            <span className="item active"></span>
                        </div>
                        <div className="button-next">
                            <Link to="/cartPage" className="next-page-buy">
                                <span className="text">خرید</span>
                                <IconName name="chevron_left" className="icon"/>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BuyPageResponsive;
